import React, { Component } from "react";
import "./Header.scss";
import ColorHelper from "../../helper/ColorHelper";
import { ButtonIcon } from "global-components-library";

export default class Header extends Component {

  minimize = () => {
    console.log('Rodrigo Minimize');
    this.props.minimize();
  };

  closeConversation = () => {
    console.log('Rodrigo closeConversation');
    this.props.closeConversation();
  };

  render() {
    let { headerImgSrc, headerImgHeight, headerImgWidth, embedded, showHeaderTitle,headerTittleTextColor,headerHeight,headerColor } = window["boot"];
    const { header: headerLabels } = window["labels"];
    return (
      <div className="header" style={{ ...({backgroundColor:headerColor}),...(embedded && {padding: 0}), height: headerHeight }}>
        {showHeaderTitle && <div style={{color:headerTittleTextColor}}>{headerLabels.title}</div>}
        <div>
          <img
            src={headerImgSrc}
            alt="headerImgSrc"
            id="header-logo-img"
            style={{
              width: headerImgWidth,
              height: headerImgHeight,
            }}
          />
        </div>
        <div className="icon-wrapper">
          {!embedded && <ButtonIcon icon={"minus"} onClick={this.minimize} />}
          {this.props.isShowBtnClose && (
            <ButtonIcon icon={"close"} onClick={this.closeConversation} />
          )}
        </div>
      </div>
    );
  }
}
